<template>
  <div class="LoyaltySteps">
    <LoyaltyStep v-for="item in items" :key="item.heading" :item="item" />
  </div>
</template>

<script>
import LoyaltyStep from "@/components/loyalty/LoyaltyStep.vue";
export default {
  name: "LoyaltySteps",
  components: {
    LoyaltyStep,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.LoyaltySteps {
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 auto;
  padding: 80px 0;
  row-gap: 40px;

  @include respond-above(md) {
    column-gap: 20px;
    grid-template-columns: repeat(3, 1fr);
    max-width: 1280px;
    padding: 60px 0;
  }
}
</style>
